import React, { useEffect, useMemo, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase";
import WeaponDetailContent from "./WeaponDetailContent";
import { normalizeWeapon } from "./normalizeWeapon";

export default function WeaponDetailPanel({ weaponId }) {
    const [w, setW] = useState(null);

    const basePath = useMemo(
        () => (weaponId ? ["weapons", weaponId] : null),
        [weaponId]
    );

    const bookmarkKey = weaponId ? `weapons:${weaponId}` : null;

    useEffect(() => {
        if (!weaponId) return;

        return onSnapshot(doc(db, "weapons", weaponId), (snap) => {
            if (!snap.exists()) {
                setW(null);
                return;
            }
            setW({ id: snap.id, ...normalizeWeapon(snap.data()) });
        });
    }, [weaponId]);

    if (!weaponId) return <div style={{ padding: 16 }}>Select a weapon</div>;
    if (!w) return <div style={{ padding: 16 }}>Loading…</div>;

    return (
        <WeaponDetailContent
            w={w}
            entityId={weaponId}
            basePath={basePath}
            bookmarkKey={bookmarkKey}
        />
    );
}
